module.exports = __webpack_public_path__ + "static/img/equipOtherSkill.e8be52b7.png";